// 1
export const StatusONE = {
	en: "Awesome Coupons are at your fingertips!",
	fr: "Des CREDITS Incroyables au bout de vos doigts !",
	es: "¡Recompensas increíbles en la punta de sus dedos!",
	de: "Fantastische Prämien sind nur einen Klick entfernt!",
	it: "Fantastiche Ricompense a portata di dito!",
	pt: "Recompensas Incríveis ao alcance dos seus dedos!",
	ja: "ワンクリックでリワードをゲットできる大チャンスです！",
	ru: "Невероятные Бонусы уже почти у вас в руках!",
	nl: "Geweldig Bonustegoed binnen handbereik!",
	ar: "مكافآت رائعة تحت أصابعك!",
	no: "Utrolige bonuser ved dine fingertupper!",
	da: "Fantastiske bonusser venter på dig!",
	sv: "Otrolig bonus vid dina fingertoppar!",
	ko: "멋진 포인트가 고객님의 클릭을 기다리고 있어요!",
	fi: "Upeat palkkiot ovat sormenmitan päässä!",
	he: " בונוסים מדהימים בקצות האצבעות! ",
	tr: "Müthiş Ödüller parmaklarınızın ucunda!",
	pl: "Wspaniale! Nagrody są bardzo blisko!",
	cz: "Báječné odměny máte na dosah ruky!",
	gr: "Καταπληκτικές Ανταμοιβές είναι στη διάθεσή σας!",
	hr: "Odlične nagrade su samo jedan klik dalje!",
	ro: "Recompense Uimitoare sunt la degetul mic!",
	hu: "Szenzációs jutalmak várják Önt!",
	th: "รางวัลสุดทึ่งแค่ปลายนิ้วคุณ!",
	id: "Imbalan menarik di ujung jari Anda!",
};
// 2
export const StatusTwo = {
	en:
		"These Coupons have run out. <br/>Check back soon! More surprises waiting for you everyday!",
	fr:
		"Il n'y a plus de Crédits. <br/>Revenez bientôt nous voir !  Plus de surprises vous attendent tous les jours !",
	es:
		" Estas Recompensas se han acabado. <br/>¡Vuelva a probar pronto! ¡Le esperan más sorpresas todos los días!",
	de:
		" Estas Recompensas se han acabado. <br/>Schauen Sie bald wieder vorbei! Weitere Überraschungen warten auf Sie jeden Tag!",
	it:
		"Queste Ricompense sono già esaurite. <br/>Prova di nuovo, presto! Ogni giorno tantissime sorprese in palio!",
	pt:
		" Essas Recompensas estão esgotadas! <br/>Volte Logo! Mais surpresas esperam por você todos os dias!",
	ja:
		"当リワードは既に当選者が確定しております。 <br/>リワードは毎日更新されます。またのお越しを心よりお待ち致しております。",
	ru:
		" эти Бонусы истекли.<br/>Возвращайтесь позже и пробуйте еще раз! Еще больше сюрпризов ждет вас каждый день!",
	nl:
		" Het Bonustegoed is helaas op.<br/>Probeer het snel nog een keer. Er wachten je elke dag meer verrassingen!",
	ar: " هذه المكافآت انتهتعد مرة أخرى قريباً!  <br/>مكافآت أكثر تنتظرك ك",
	no: "Denne bonusen har tatt slutt. <br/>Kom snart tilbake. Flere overraskelser venter daglig!",
	da: " Disse bonusser er slut. <br/>Kom snart igen. Flere overraskelser venter dig, dagligt!",
	sv:
		"Denna bonus har tagit slut. <br/>Kom tillbaka snart igen. Fler överraskningar väntar varje dag!",
	ko:
		"이 포인트는 이미 품절되었습니다. <br/>곧 다시 확인하세요!매일 매일 더 많은 놀라운 소식이 고객님을 기다리고 있습니다!",
	fi:
		"Nämä palkkiot ovat loppuneet. <br/>Palaa takaisin nopeasti! Enemmän yllätyksiä odottaa sinua päivittäin!",
	he: "הבונוסים האלו אזלו. <br/> תבדוקתבדקי שוב בקרוב! עוד הפתעות מחכות לך בכל יום!  ",
	tr:
		" Bu Ödüller tükendi. <br/>Yakında kontrol etmek için geri gelin. Hergün seni daha fazla sürpriz bekliyor!",
	pl:
		" Te nagrody już się wyczerpały. <br/>Sprawdź ponownie innym razem! Każdego dnia czekają na Ciebie nowe niespodzianki!",
	cz:
		"Tyto odměny už nejsou k dispozici. <br/>Vraťte se brzy! Každý den na Vás čeká ještě více odměn!",
	gr:
		"Αυτές οι Ανταμοιβές εξαντλήθηκαν. <br/>Ελέγξτε ξανά σύντομα! Περισσότερες εκπλήξεις σας περιμένουν κάθε μέρα!",
	hr: " Ove Nagrade su istekle. <br/>Provjerite opet uskoro! Mngo iznenađenja svakodnevno!",
	ro:
		" Aceste Recompense s-au finalizat. <br/>Verifică în curând! Mai multe surprize te așteaptă în fiecare zi!",
	hu:
		"A jutalom elfogyott.  <br/>Nézzen vissza később! Még több meglepetés várja Önt minden nap!",
	th:
		"รางวัลเหล่านี้หมดแล้ว <br/>กลับมาตรวจดูใหม่เร็ว ๆ นี้! เซอร์ไพรส์อีกมากมายรอคุณอยู่ทุกวัน!",
	id:
		"Imbalan ini telah habis. <br/>Kembalilah lagi nanti! Lebih banyak kejutan untuk Anda setiap harinya!",
};
// 3
export const StatusThree = {
	en: "You have already got these Coupons. <br/>Please come back tomorrow.",
	fr: " Vous avez déjà ces Crédits.  <br/>Merci de revenir demain.",
	es: "Ya tiene estas Recompensas. <br/>Por favor, vuelva mañana.",
	de: " Sie haben diese Prämien bereits bekommen. <br/>Bitte kommen Sie morgen wieder.",
	it: " Hai già guadagnato queste Ricompense. <br/> Ti invitamo a riprovare domani.",
	pt: "Você já ganhou essa recompensa. <br/>Por favor volte amanha!",
	ja:
		"大変申し訳ございません。本日のお客様向けリワードは終了となっております。 <br/>明日のお越しをお待ち致しております。",
	ru: "К сожалению, вы уже получили эти Бонусы.  <br/>Пожалуйста, возвращайтесь завтра.",
	nl: "Je hebt dit Bonustegoed al gekregen.  <br/>Kom morgen nog eens terug.",
	ar: "نأسف لقد حصلت على هذه المكافآت الرجاء العودة غداً",
	no: "Du har allerede mottatt denne bonusen. <br/>Kom tilbake i morgen.",
	da: "Du har allerede modtaget denne bonus. <br/>Kom tilbage i morgen.",
	sv: "Du har redan fått denna bonus.  <br/>Kom tillbaka imorgon igen.",
	ko: "죄송합니다!고객님은 이미 이 포인트를 얻으셨습니다. <br/>내일 다시 시도해 주시기 바랍니다.",
	fi: "Sinä olet jo saanut nämä palkkiot. <br/>Ole ystävällinen ja palaa takaisin huomenna.",
	he: "אנחנו מצטערים! כבר קיבלת <br/> את הבונוס הזה. בבקשה תחזורתחזרי מחר. ",
	tr: "Bu Ödüller henüz yüklenmemiş. <br/>Lütfen yarın geri dönün.",
	pl: "Otrzymał-eś/aś już te nagrody.  <br/>Proszę spróbować jutro.",
	cz: "Tyto odměny již máte. <br/>Nezapomeňte se vrátit zítra.",
	gr: "Έχετε ήδη πάρει αυτές τις Ανταμοιβές.  <br/>Παρακαλούμε επιστρέψτε αύριο.",
	hr: "Već ste zaradili ove nagrade.  <br/>Vratite se opet sutra",
	ro: "Ați beneficiat de aceste RecompenseVă rugăm să vă întoarceți mâine.",
	hu: "A jutalmat már jóváírtuk.  <br/>Kérjük, nézzen vissza holnap. ",
	th: "คุณได้รับรางวัลเหล่านี้แล้ว<br/>โปรดกลับมาใหม่พรุ่งนี้",
	id: "Anda sudah mendapatkan Imbalan ini.  <br/>Silakan kembali lagi besok.",
};
// 4
export const StatusFour = {
	en: 'Check your <a href="%s">Coupons</a> account now.',
	fr: 'Vérifiez votre solde de <a href="%s">Crédits de Fidélité &amp; Avoirs</a>.',
	es: 'Eche un vistazo a su cuenta de <a href="%s">Recompensas y Crédito</a>ahora.',
	de: 'Überprüfen Sie jetzt Ihr<a href="%s">Treueguthaben &amp; Gutschriften - Konto.</a>',
	it: 'Dai un\'occhiata a  <a href="%s">Ricompense e credito</a>nel tuo account.',
	pt: 'Confira sua conta de <a href="%s">Recompensas e Créditos</a> agora.',
	ja: '今すぐ <a href="%s">リワード＆クレジット</a>アカウントをご確認下さい。',
	ru: 'Проверить <a href="%s">Внутренний / Бонусный </a>счет сейчас.',
	nl: 'Bekijk nu je <a href="%s">Tegoed &amp; Bonustegoed</a> account.',
	ar: 'تحقق من <a href="%s">المكافآت و الزيادات</a>في حسابك الآن.',
	no: 'Sjekk din <a href="%s">Bonus &amp; Kreditt</a>-konto nå.',
	da: ' Tjek din <a href="%s">Bonus &amp; Kredit</a>konto nu.',
	sv: 'Kolla ditt <a href="%s">Bonus- och kreditkonto</a>nu.',
	ko: '고객님의 <a href="%s">포인트 &amp; 적립금 </a>계정을 지금 확인하세요.',
	fi: 'Tarkista <a href="%s">palkkio- ja hyvitystilisi</a>nyt.',
	he: 'בדקו את <a href="%s">חשבון מענקים וקרדיט</a>עכשיו',
	tr: ' Şimdi, Ödüller ve Kredi <a href="%s"> hesabınızı</a> kontrol edin.',
	pl: 'Sprawdź swoje <a href="%s">konto Premie i Środki</a> już teraz.',
	cz: 'Zkontrolujte svůj účet <a href="%s">Coupons &amp; Credit</a>právě teď.',
	gr: ' Ελέγξτε τον <a href="%s">Ανταμοιβές &amp; Πίστωση</a>λογαριασμό σας τώρα.',
	hr: ' Provjerite Vaš račun <a href="%s">Nagrada i kredita</a> sada.',
	ro: 'Verificați<a href="%s">Recompense &amp; Credit</a>cont acum.',
	hu: 'Nézze meg <a href="%s">Jutalmak &amp; jóváírások</a>számláját most.',
	th: `ตรวจสอบบัญชี <a href="%s">รางวัลและเครดิต</a> ของคุณตอนนี้`,
	id: 'Silakan periksa akun <a href="%s">Imbalan &amp; Kredit </a> Anda sekarang.',
};

export const ReceivedSuccess = {
	en: "Received successfully",
	fr: "Reçu avec succès",
	es: "Recibido con éxito",
	de: "Erfolgreich empfangen",
	it: "Ricevuto con successo",
	pt: "Recebido com sucesso",
	ja: "正常に受信されました",
	ru: "Получено успешно",
	nl: "Met succes ontvangen",
	ar: "استقبل بنجاح",
	no: "Mottatt",
	da: "Modtaget med succes",
	sv: "Fick framgångsrikt",
	ko: "성공적으로 수신 됨",
	fi: "Vastaanotto onnistui",
	he: "התקבל בהצלחה",
	tr: "Otrzymano pomyślnie",
	pl: "Úspěšně přijato",
	cz: "Başarıyla alındı",
	gr: "Primit cu succes",
	hr: "Sikeresen megkapta",
	ro: "Λήφθηκε με επιτυχία",
	hu: "Prijaté úspešne",
	th: "ได้รับเรียบร้อย",
	id: "Berhasil diterima",
};

export const OKText = {
	en: "OK",
	fr: "OK",
	es: "OK",
	de: "OK",
	it: "OK",
	pt: "OK",
	ja: "閉じる",
	ru: "OK",
	nl: "OK",
	ar: "حسناً",
	no: "OK",
	da: "OK",
	sv: "OK",
	ko: "OK",
	fi: "OK",
	he: "אישור",
	tr: "Tamam",
	pl: "OK",
	cz: "OK",
	gr: "Εντάξει",
	hr: "OK",
	ro: "OK",
	hu: "OK",
	th: "ตกลง",
	id: "OK",
};

export const CouponSuccessfullyCopied = {
	en: "Coupon successfully copied",
	cz: "Zobrazit můj košík",
	da: "Kupon kopieret",
	de: "Coupon erfolgreich kopiert",
	gr: "Δείτε το καλάθι μου",
	es: "Cupón copiado con éxito",
	hr: "Kupon je uspješno kopiran",
	fr: "Coupon copié avec succès",
	hu: "A kupon sikeresen másolt",
	it: "Coupon copiato con successo",
	ja: "クーポンは正常にコピー",
	ko: "쿠폰이 성공적으로 복사",
	nl: "Coupon gekopieerd",
	no: "Kupongen ble kopiert",
	pl: "Kupon z powodzeniem skopiowane",
	pt: "Ver meu carrinho",
	ro: "Cuponul copiate cu succes",
	ru: "Купон успешно скопирована",
	sv: "Kupong har kopierats",
	th: "คูปองคัดลอกสำเร็จ",
	tr: "Kupon başarıyla kopyalandı",
	ar: "قسيمة نسخ بنجاح",
	he: "קופון הועתק בהצלחה",
	id: "Kupon berhasil disalin",
	fi: "Kuponki kopioitiin",
};
